const zIndices = {
  background: -1,
  header: 2,
  mobileNav: 18,
  mobileNavButton: 19,
  desktopNavMenu: 18,
  desktopNavButton: 19,
  registryProductModal: 20,
};

export default zIndices;
